<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <div class="flex xs12 sm2">
                <v-select
                        :items="[{
                          text: '기사 고유번호',
                          value: 'driverId'
                        },
                        {
                          text: '기사 이용이력 고유번호',
                          value: 'id'
                        },
                        {
                          text: '기사 이름',
                          value: 'driverName'
                        }]"
                        name="header"
                        v-model="searchFormModel.filter"
                        label="header"
                ></v-select>
              </div>

              <v-text-field
                      flat
                      solo
                      prepend-icon="search"
                      placeholder="Type something"
                      v-model="searchFormModel.filterText"
                      hide-details
                      class="hidden-sm-and-down"
                      @keyup.enter="searchFilter"
              ></v-text-field>
              <v-btn icon @click="searchFilter">
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="complex.items"
                :rows-per-page-items="[10,25,50]"
                class="elevation-1"
                item-key="id"
                must-sort
                :total-items="totalItems"
                :loading="loading"
                :pagination.sync="pagination"
                >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center"><a @click="openDetail(props.item.id)">{{ props.item.id }}</a></td>
                  <td class="text-sm-center"><a @click="openDriverDetail(props.item.driverId)">{{ props.item.driverId }}</a></td>
                  <td class="text-sm-center">{{ props.item.driver.personalInfo.name }}</td>
                  <td class="text-sm-center">{{ props.item.carNum }}</td>
                  <td class="text-sm-center">{{ props.item.startLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.endLocationName }}</td>
                  <td class="text-sm-center">{{ props.item.taxiFee }} 원</td>
                  <td class="text-sm-center">{{ props.item.extraFee }} 원</td>
                  <td class="text-sm-center">{{ props.item.serviceFee }} 원</td>
                  <td class="text-sm-center">{{ props.item.totalFee + props.item.serviceFee }} 원</td>
                  <td class="text-sm-center">{{ props.item.callOption }}</td>
                  <td class="text-sm-center">{{ props.item.payMethod }}</td>
                  <td class="text-sm-center">{{ props.item.state }}</td>
                  <td class="text-sm-center">{{ props.item.regDate }}</td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      pagination: {
        sortBy: 'id',
        descending: true,
        rowsPerPage: 10,
        page: 1
      },
      searchFormModel: {
        filter: 'driverId',
        filterText: ''
      },
      totalItems: 0,
      loading: true,
      complex: {
        headers: [
          {
            text: '이력번호',
            value: 'id',
            align: 'center'
          },
          {
            text: '기사 고유번호',
            value: 'driverId',
            align: 'center'
          },
          {
            text: '기사 이름',
            value: 'driver.personalInfo.name',
            align: 'center'
          },
          {
            text: '차량번호',
            value: 'carNum',
            align: 'center'
          },
          {
            text: '출발지',
            value: 'startLocationName',
            align: 'center'
          },
          {
            text: '도착지',
            value: 'endLocationName',
            align: 'center'
          },
          {
            text: '미터기 요금',
            align: 'center',
            sortable: false
          },
          {
            text: '추가 요금(통행료)',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 수익',
            align: 'center',
            sortable: false
          },
          {
            text: '최종 요금 (미터기 요금 + 추가 요금 + 기사 수익)',
            align: 'center',
            sortable: false
          },
          {
            text: '콜 종류',
            value: 'callOption',
            align: 'center'
          },
          {
            text: '결제 수단',
            value: 'payMethod',
            align: 'center'
          },
          {
            text: '상태',
            value: 'state',
            align: 'center'
          },
          {
            text: '등록시간',
            value: 'regDate',
            align: 'center'
          }
        ],
        items: []
      }
    };
  },
  watch: {
    pagination: {
      handler () {
        if (top.getApp.prevPageName === 'DriverUsageHistoryPage') {
          if(top.getApp.prevPagination != null) {
            this.pagination = top.getApp.prevPagination;
          }

          if(top.getApp.prevSearchFormModel != null) {
            this.searchFormModel = top.getApp.prevSearchFormModel;
          }

          top.getApp.clearPrevData();
        }

        this.banbanCreated();
      },
      deep: true
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }
  },
  methods: {
    banbanCreated () {
      this.loading = true;

      const parameters = {
        method: 'searchDriverUsageRecords',
        pageNum: this.pagination.page - 1,
        pageSize: this.pagination.rowsPerPage,
        sortName: this.pagination.sortBy,
        order: this.pagination.descending == true ? 'desc' : 'asc',
        filter: this.searchFormModel.filter,
        filterText: this.searchFormModel.filterText
      };
      this.$store.dispatch('banbanAPI', parameters)
        .then(({ data }) => {
          if (data.statusCode != null && data.statusCode != '200'){
            throw data.message;
          }
          this.complex.items = data.content;
          this.totalItems = data.totalElements;
          this.loading = false;
          top.getApp.progress.dialog = false;
        })
        .catch((error) => {
          if (top.getApp.commonError == null) {
            alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
          }
          top.getApp.commonError = null;
          top.getApp.progress.dialog = false;
        });
    },
    openDetail (id) {
      top.getApp.addPrevData('DriverUsageHistoryPage', this.pagination, this.searchFormModel);
      this.$router.push('/usage/driverUsageHistory/' + id);
    },
    openDriverDetail (id) {
      top.getApp.addPrevData('DriverUsageHistoryPage', this.pagination, this.searchFormModel);
      this.$router.push('/member/driverMemberDetail/' + id);
    },
    searchFilter () {
      this.banbanCreated();
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/usage/DriverUsageHistory.vue